// MARK: Used in V2 start
export {
  storyblokUrlToInternalUrl,
  getUrlFromStoryblokLink,
  linkIsNotNull,
  storyblokLinkToYocoLink,
} from "./V2/consolidateItem"

export const linkIsExternalUrl = (
  link: Storyblok.Link | YocoCom.YocoLink | string
): boolean => {
  const isStringLink = typeof link === "string"
  const isStoryblokLink = !isStringLink && "linktype" in link
  const urlReference = isStringLink
    ? link
    : isStoryblokLink
      ? link.url || link.cached_url
      : link.url
  const isEmail =
    (isStringLink && link.includes("mailto:")) ||
    (isStoryblokLink && link.linktype === "email")

  return (
    isEmail || urlReference?.includes("http") || urlReference?.includes("tel:")
  )
}

export const isEditorWindow = (): boolean => {
  return (
    typeof window !== "undefined" &&
    window?.location?.pathname?.includes("/editor/")
  )
}

export const parseStoryblokDate = (date?: string): Date | null => {
  return date ? new Date(date.replace(" ", "T")) : null
}

export const setDummyCartData = () => {
  if (typeof window !== "undefined") {
    localStorage.setItem("cartId", "112eb12b-0444-49a8-9d7c-74cbd9a3dfb8")
    localStorage.setItem(
      "cartProducts",
      JSON.stringify([
        {
          id: "ca359efc-a65a-45a3-8dca-e6159c6ced34",
          bundleCode: "KHUMO_PRINT_AND_STAND",
          quantity: 1,
          type: "bundle",
        },
      ])
    )
  }
}
